import axios from 'axios';
import { ParamGetDocument } from 'types/documents';
import * as qs from 'qs';
import { ParamGetAssetIssues } from 'types/loctions';

export const getDocumentations = async (params: Partial<ParamGetDocument>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/documentations?${query}`);
  return data;
};

export const createDocumentation = async (formData: FormData) => {
  const { data } = await axios.post('/documentations', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

export const getDocumentationsAssets = async (params: Partial<ParamGetDocument>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/documentations/assets?${query}`);
  return data;
};
export const getDocumentationsModel = async (params: Partial<ParamGetDocument>) => {
  const query = qs.stringify({
    ...params
  });
  const { data } = await axios.get(`/documentations/models?${query}`);
  return data;
};

export const deleteDocumentationLibrary = async (id: number) => {
  const { data } = await axios.delete(`/documentations/${id}`);
  return data;
};

export const deleteDocumentationAsset = async (id: number) => {
  const { data } = await axios.delete(`/documentations/assets/${id}`);
  return data;
};

export const deleteDocumentationModel = async (id: number) => {
  const { data } = await axios.delete(`/documentations/models/${id}`);
  return data;
};

export const getDocumentationCategories = async () => {
  const { data } = await axios.get(`/documentation-categories`);
  return data as {
    success: boolean;
    categories: {
      id: string;
      slug: string;
      sortOrder: number;
      createdAt: string;
      updatedAt: string;
    }[];
  };
};

export const createDocumentationCategory = async (body: { slug: string; sortOrder: number }) => {
  const { data } = await axios.post(`/documentation-categories`, body);
  return data;
};

export const patchDocumentationCategory = async (
  id: number,
  body: { sortOrder?: number; slug?: string }
) => {
  const { data } = await axios.patch(`/documentation-categories/${id}`, body);
  return data;
};

export const deleteDocumentationCategory = async (id: number) => {
  const { data } = await axios.delete(`/documentation-categories/${id}`);
  return data;
};

export const generateFileValidationTab = async (params: Partial<ParamGetAssetIssues>) => {
  const query = qs.stringify(
    {
      ...params
    },
    {
      arrayFormat: 'repeat',
      skipNulls: true
    }
  );
  try {
    const response = await axios.get(`/inspections/submitted-assets/export?${query}`, {
      responseType: 'blob'
    });
    const disposition = response.headers['content-disposition'];
    let filename = 'downloaded-file';
    if (disposition && disposition.includes('filename=')) {
      filename = disposition.split('filename=')[1].replace(/["']/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Download failed:', err);
  }
};
